import BaseSelect from 'components/Selects/BaseSelect/BaseSelect';
import { findSelectOption } from 'components/Selects/BaseSelect/utils/baseSelect.utils';
import BaseModal from 'components/Modals/BaseModal';
import { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import type { RawService } from '../types/ServiceManager.types';

interface AddServiceModalProps {
  show: boolean;
  onClose: () => void;
  onAdd: (serviceName: string) => void;
  availableServices?: RawService[];
}

/**
 * Modal that lets the user pick a removed/missing service and re-add it.
 */
export default function AddServiceModal({
  show,
  onClose,
  onAdd,
  availableServices = [],
}: AddServiceModalProps) {
  const [selectedName, setSelectedName] = useState('');

  useEffect(() => {
    if (show) {
      setSelectedName('');
    }
  }, [show]);

  const handleSubmit = () => {
    if (!selectedName) return;
    onAdd(selectedName);
    onClose();
  };

  const serviceOptions = availableServices.map((service) => ({
    value: service.name,
    label: service.name,
  }));

  return (
    <BaseModal
      show={show}
      handleShow={onClose}
      size="md"
      title="Add Service"
      contentStyle={{}}
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={!selectedName}>
            Add Service
          </Button>
        </>
      }
    >
      <Form>
        <Form.Group controlId="addServiceTemplate">
          <Form.Label className="text-theme" htmlFor="addServiceSelect">
            Choose a service to add
          </Form.Label>
          <BaseSelect
            inputId="addServiceSelect"
            isSearchable
            selectProps={{
              'aria-label': 'Select a service to add',
              options: serviceOptions,
              value: findSelectOption(serviceOptions, selectedName),
              placeholder: 'Select a service',
              onChange: (option: { value: string } | null) => setSelectedName(option?.value ?? ''),
            }}
          />
        </Form.Group>
      </Form>
    </BaseModal>
  );
}
